import {get, post, postJson} from '../axios'
// 精准营销批次短信记录

const RESOURCE_BASE_PATH = '/precisionMarketing'
// const RESOURCE_BASE_PATH = 'http://116.196.113.156/jd-yusms/precisionMarketing'

// 短信效果分析
export const getRecordListOfficial = p => get(`${RESOURCE_BASE_PATH}/page/`, p);

// 获取精准营销记录（用于二次发送回显）
export const getRecordMarketing = p => get(`${RESOURCE_BASE_PATH}/record`, p);


// 短信效果分析
export const getSmsEffectGet = p => get(`${RESOURCE_BASE_PATH}/smsEffectGet/`, p);

// 导出营销效果分析数据
export const exportSmsEffect = p => get(`${RESOURCE_BASE_PATH}/exportSmsEffect`, p);

// 营销短信的取消发送
export const cancelSendSms = p => post(`${RESOURCE_BASE_PATH}/cancelSendSms`, p);

// 保存草稿
export const saveDraft = p => post(`${RESOURCE_BASE_PATH}/saveDraft`, p);

// 获取草稿
export const getDraft = p => get(`${RESOURCE_BASE_PATH}/getDraft`, p);
